import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const PartnersPage: React.FC = () => {
  return <EventPageTemplate {...eventData.partners} />;
};

export default PartnersPage;
